/* Collection hero: raises the stylesheet's own sway on the contour lines the
   pointer passes, eased both ways. Bound to the document, never the section: a
   facet re-render replaces the hero whole and the listeners must outlive it. */
(function () {
  'use strict';

  if (window.bqHeroBreeze) return;
  window.bqHeroBreeze = true;

  // No hover on touch: the stylesheet's sway stands alone there.
  if (!matchMedia('(hover: hover) and (pointer: fine)').matches) return;
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  // How far above and below the pointer a line still takes the gust, in px.
  const REACH = 170;
  // Time constant of the rise and the fall; three of them settle in 600ms.
  const TAU = 200;

  let wave = null;
  let lines = [];
  let pointer = null;
  let last = 0;
  let queued = false;
  let asleep = true;

  /* A line's place is a viewBox fraction, read once, and can sit outside 0 to 1
     since the paths overhang the field; the live box converts it back. */
  function bind() {
    if (wave && wave.isConnected) return true;
    wave = document.querySelector('.bq-col-hero__wave');
    lines = [];
    if (!wave) return false;
    const span = wave.viewBox.baseVal.height || 1;
    wave.querySelectorAll('path').forEach(function (el) {
      const box = el.getBBox();
      lines.push({ el: el, frac: (box.y + box.height / 2) / span, gain: 0, wrote: '' });
    });
    return true;
  }

  function kick() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(frame);
  }

  function frame(now) {
    queued = false;
    if (!bind()) {
      pointer = null;
      return;
    }
    const box = wave.getBoundingClientRect();
    const inside =
      !!pointer &&
      pointer.x >= box.left &&
      pointer.x <= box.right &&
      pointer.y >= box.top &&
      pointer.y <= box.bottom;
    // Nothing to lift and nothing left to fall: sleep until the pointer is back
    // over the hero.
    if (!inside && asleep) {
      last = 0;
      return;
    }
    const dt = last ? Math.min(now - last, 100) : 16;
    last = now;
    const k = 1 - Math.exp(-dt / TAU);
    let live = false;
    for (let i = 0; i < lines.length; i++) {
      const line = lines[i];
      let want = 0;
      if (inside) {
        const away = Math.abs(pointer.y - (box.top + line.frac * box.height));
        // Squared, so the gust has a centre rather than a rim.
        want = away < REACH ? (1 - away / REACH) * (1 - away / REACH) : 0;
      }
      line.gain += (want - line.gain) * k;
      if (Math.abs(want - line.gain) > 0.002) {
        live = true;
      } else {
        line.gain = want;
      }
      // Most lines are out of reach and hold their value: writing them anyway
      // would invalidate the whole field's style every frame.
      const next = line.gain.toFixed(3);
      if (next !== line.wrote) {
        line.wrote = next;
        line.el.style.setProperty('--bq-breeze', next);
      }
    }
    asleep = !inside && !live;
    if (live) {
      kick();
    } else {
      last = 0;
    }
  }

  addEventListener(
    'pointermove',
    function (event) {
      if (event.pointerType === 'touch' || event.pointerType === 'pen') return;
      pointer = { x: event.clientX, y: event.clientY };
      kick();
    },
    { passive: true }
  );

  // Leaving the window fires no move, so the last position would stand.
  document.addEventListener('pointerleave', function () {
    pointer = null;
    kick();
  });

  // A settled gust would otherwise stay on lines the page has scrolled off.
  addEventListener(
    'scroll',
    function () {
      if (pointer) kick();
    },
    { passive: true }
  );
})();
